import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15951eca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Maintenance")
], -1))
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "pl-lg-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-maintenance-user"
}, "Technician", -1))
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-maintenance-equipment"
}, "Equipment", -1))
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-maintenance-name"
}, "Type of Job", -1))
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-maintenance-remarks"
}, "Service Report Log", -1))
const _hoisted_20 = { class: "col-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_n_button, {
            class: "mr-3 flex-fill",
            type: "primary",
            dashed: "",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/maintenance/create`)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" + Add Maintenance ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock("form", { key: _ctx.maintenance }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_n_select, {
                  id: "search-maintenance-user",
                  value: _ctx.maintenance.user_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.maintenance.user_id) = $event)),
                  options: _ctx.userOptions,
                  loading: _ctx.userLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onUserSearch
                }, null, 8, ["value", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_n_select, {
                  id: "search-maintenance-equipment",
                  value: _ctx.maintenance.equipment_id,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maintenance.equipment_id) = $event)),
                  options: _ctx.equipmentOptions,
                  loading: _ctx.equipmentLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onEquipmentSearch
                }, null, 8, ["value", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_n_select, {
                  id: "search-maintenance-name",
                  value: _ctx.maintenance.name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.maintenance.name) = $event)),
                  options: _ctx.jobOptions,
                  loading: _ctx.jobLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onJobSearch
                }, null, 8, ["value", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_n_input, {
                  id: "search-maintenance-remarks",
                  value: _ctx.maintenance.remarks,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maintenance.remarks) = $event)),
                  type: "text",
                  size: "large",
                  placeholder: "Service Report Log"
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_n_button, {
            class: "mr-3",
            type: "primary",
            onClick: _ctx.searching
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SHOW RESULTS ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_n_button, {
            strong: "",
            secondary: "",
            type: "primary",
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(" RESET ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    ])
  ]))
}